export default {
	tenantId: "boc",
	appId: "coverStudio",

	fileSystem: {
		bucketName: "boc"
	}
}
